import { createAsyncThunk } from '@reduxjs/toolkit';
import { getProjectThread } from 'store/chat/services/getProjectThread.service';
import { loadThreadUsersThunk } from './loadThreadUsers';

export const getProjectThreadThunk = createAsyncThunk(
  'chat/getProjectThread',
  async ({ projectId }, { getState, dispatch }) => {
    const thread = await getProjectThread(projectId);

    // Load users for this thread if it matches the current project
    const state = getState();
    if (projectId === state.chatSlice.project?.id) {
      await dispatch(loadThreadUsersThunk({ thread }));
    }

    return thread;
  }
);
